export default function ProgramIncludes() {
  const stages = [
    { icon: 'ri-search-eye-line', title: 'Диагностика', desc: 'Анализ текущей переговорной практики: типы переговоров, частые сценарии, болевые точки, уровень подготовки команды.' },
    { icon: 'ri-chat-voice-line', title: 'Интервью', desc: 'Глубинные беседы с участниками и руководителями. Выявление реальных кейсов, страхов, ограничений и точек роста.' },
    { icon: 'ri-file-settings-line', title: 'Адаптация программы', desc: 'Разработка индивидуального содержания под специфику компании, отрасль, продукт и типовые переговорные ситуации.' },
    { icon: 'ri-presentation-line', title: 'Практический тренинг', desc: '80% практики: переговорные поединки, ролевые игры, разбор реальных кейсов компании в режиме реального времени.' },
    { icon: 'ri-sword-line', title: 'Переговорные поединки', desc: 'Моделирование сложных переговоров с обратной связью. Участники ведут переговоры друг с другом и с тренером.' },
    { icon: 'ri-file-search-line', title: 'Разбор кейсов', desc: 'Детальный анализ реальных переговорных ситуаций участников. Что пошло не так, где точка перелома, как улучшить.' },
    { icon: 'ri-task-line', title: 'Домашняя практика', desc: 'Закрепление навыков между модулями. Подготовка к реальным переговорам, анализ проведённых встреч.' },
    { icon: 'ri-refresh-line', title: 'Сопровождение', desc: 'Поддержка после тренинга: разбор сложных переговоров, корректировка стратегии, ответы на вопросы в чате.' },
  ];

  return (
    <section id="program" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Из чего состоит программа <strong>тренинга по переговорам</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            <strong>Корпоративный тренинг по переговорам</strong> — это не разовое мероприятие, а 8-этапная система. Каждый этап работает на закрепление навыков и формирование единой культуры переговоров в компании.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {stages.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-6 hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group cursor-default">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-600 transition-colors duration-300 flex-shrink-0">
                <i className={`${item.icon} text-lg text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <div className="text-xs text-teal-600 font-semibold mb-1">Этап {i + 1}</div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}